export default {
    container: {
        width: ['100%', '100%', '400px', '400px']
    },
    title: {
        textTransform: 'uppercase',
        fontSize: '24px',
        fontWeight: 700,
        marginBottom: 2.5
    },
    inputWrapper: {
        border: '1px solid #676767',
        marginBottom: 8,
        position: 'relative',
        height: '40px'
    },
    input: {
        height: '100%',
        border: 'none',
        padding: '10px 12px'
    },
    button: {
        position: 'absolute',
        height: '100%',
        background: 'transparent',
        zIndex: 2,
        right: 0,
        paddingRight: '12px',
        textDecoration: 'none',
        textTransform: 'uppercase',
        fontSize: '12px',
        _hover: {
            textDecoration: 'none'
        }
    },
    store: {
        name: {
            fontWeight: '600'
        }
    }
}
